<template>
    <el-container>
        <el-header>
          <header-com></header-com>
        </el-header>
        <el-main>
          <router-view/> 
        </el-main>
        <el-footer>
          <footer-com></footer-com>
        </el-footer>
    </el-container>
</template>

<script>
import headerCom from '../components/header'
import footerCom from '../components/footer'
export default {
   
    components: {
      headerCom,
      footerCom,
    },
   
  
}
</script>
<style lang="scss" scoped>
.el-header{
  height: 0 !important;
}

  .el-header, .el-footer {
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
   
  }
 
  .el-main{
     padding: 0;
     overflow: hidden;
  }
  
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }

</style>


// WEBPACK FOOTER //
// src/layouts/header-footer.vue